import { constantsTypes } from "../reduxConstants";

const initialValue = {value: false};

export const comingSoonMovieReduce = (state = initialValue, action) => {
  // console.log(action);
  switch (action.type) {
    case constantsTypes.COMING_SOON_MOVIE:
      return action.value
    default:
      return state
  }
}